// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"6e621585","498":"e4f75cb3","703":"f759a26a"}[chunkId] + ".chunk.js";
};